<app-header-desktop *appDesktop breakpointClass="desktop"></app-header-desktop>
<app-header-desktop *appTabletLandscape breakpointClass="landscape"></app-header-desktop>
<app-header-desktop *appTabletPortrait breakpointClass="portrait"></app-header-desktop>
<app-header-mobile *appMobile></app-header-mobile>
